import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './routes/Home'
import Header from './assets/components/Header'
import Aboutus from './routes/Aboutus';
import Ourwork from './routes/Ourwork';
import Blog from 'routes/Blog';
import Careers from 'routes/Careers';
import ContactUs from 'routes/ContactUs';
import Startups from 'routes/Startups';
import Faq from 'routes/Faq';
import JobPost from 'routes/JobPost';
import PFA from 'routes/blog-articles/PFA';
import PearlX from 'routes/blog-articles/PearlX';
import Barclays from 'routes/blog-articles/Barclays';
import AdminPartners from 'routes/blog-articles/AdminPartners';
import JTF from 'routes/blog-articles/JTF';
import CleanItSupply from 'routes/blog-articles/CleanItSupply';
import CookiePolicy from './routes/CookiePolicy';
import TermsAndConditions from './routes/TermsAndConditions';
import Constructive from 'routes/blog-articles/Constructive';
import PrivacyPolicy from './routes/PrivacyPolicy';
import MTBank from 'routes/blog-articles/MTBank'

const App: React.FC = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/ourwork" element={<Ourwork />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/case-studies" element={<Blog />} />
        <Route path="/case-studies/pfa" element={<PFA />} />
        <Route path="/case-studies/pearlx" element={<PearlX />} />
        <Route path="/case-studies/barclays" element={<Barclays />} />
        <Route path="/case-studies/adminpartners" element={<AdminPartners />} />
        <Route path="/case-studies/jtf" element={<JTF />} />
        <Route path="/case-studies/cleanitsupply" element={<CleanItSupply />} />
        <Route path="/case-studies/mtbank" element={<MTBank />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/startups" element={<Startups />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/jobpost" element={<JobPost />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/case-studies/constructive" element={<Constructive />} />
      </Routes>

    </Router>
  );
};

export default App;
